<script lang="ts">
	import type { Snippet } from 'svelte'

	interface Props {
		name: string
		href?: string | null
		active?: boolean
		disabled?: boolean
		children?: Snippet
		onclick?: (event: Event) => void
	}

	let { name, href = null, active = false, disabled = false, children, onclick }: Props = $props()
</script>

<svelte:element
	this={href ? 'a' : 'div'}
	class="
    {active
		? 'bg-primary-200 text-primary-500 dark:bg-primary-900 dark:text-primary-400 font-bold'
		: ''}
    {disabled ? 'text-gray-300' : ''}
    {active || disabled ? 'pointer-events-none' : ''}
    flex h-7 w-7 items-center justify-center rounded hover:bg-gray-200"
	data-test={name}
	{href}
	{onclick}
	role="button"
	tabindex={disabled ? -1 : 0}
>
	{@render children?.()}
</svelte:element>
